// components/ModalUser.tsx
import React, { useState } from 'react';
import Modal from 'Common/Components/Modal';

interface FormField {
  label: string;
  name: string;
  type: string;
  placeholder: string;
}

interface ModalUserProps {
  show: boolean;
  isEdit: boolean;
  onHide: () => void;
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
  validation: any;
  formFields: FormField[];
  role_id: string; // اضافه کردن این prop
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  options: { value: string; label: string }[];
  handleSelectrole: (value: string) => void;
  disabled: boolean;
  setdisabled: (disabled: boolean) => void;
}

const ModalUser: React.FC<ModalUserProps> = ({
  show,
  isEdit,
  onHide,
  onSubmit,
  validation,
  formFields,
  role_id, // دریافت prop
  setIsOpen,
  isOpen,
  options,
  handleSelectrole,
  disabled,
  setdisabled
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
    >
      <Modal.Header
        className="flex items-center justify-between p-4 border-b dark:border-zink-500"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
      >
        <Modal.Title className="text-16">
          {!!isEdit ? "به روز رسانی اطلاعات" : "اضافه کردن کاربر جدید"}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <form
          className="create-form"
          id="create-form"
          onSubmit={validation.handleSubmit}
        >
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
            {formFields.map((field: FormField, index: number) => (
              <div key={index} className="xl:col-span-6 text-gray-800">
                <label className="inline-block dark:text-white mr-1 mb-2 text-base font-medium">
                  {field.label}
                </label>
                <input
                  type={field.type}
                  className="form-input w-full placeholder-gray-400 placeholder:text-[12px]"
                  placeholder={field.placeholder}
                  name={field.name}
                  autoComplete="off"
                  onChange={validation.handleChange}
                  value={
                    validation.values[
                      field.name as keyof typeof validation.values
                    ] || ""
                  }
                />
                {validation.touched[
                  field.name as keyof typeof validation.touched
                ] &&
                  typeof validation.errors[
                    field.name as keyof typeof validation.errors
                  ] === "string" && (
                    <p className="text-red-400">
                      {String(
                        validation.errors[
                          field.name as keyof typeof validation.errors
                        ]
                      )}
                    </p>
                  )}
              </div>
            ))}

            {/* انتخاب نقش */}
            <div className="relative lg:w-[13.5rem] w-full mt-2">
              <label htmlFor="" className="mb-4 mr-2">
                نقش
              </label>
              <div
                onClick={() => setIsOpen(!isOpen)}
                className="px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm cursor-pointer dark:border-gray-600 text-gray-700"
              >
                {options.find((opt) => opt.value === role_id)?.label ??
                  "لطفا نقش کاربر را انتخاب کنید..."}
              </div>
              {isOpen && (
                <div className="absolute bottom-full mb-2 w-full bg-gray-800 border border-gray-300 rounded-lg shadow-lg dark:border-gray-600 z-10">
                  {options.map((option, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        handleSelectrole(option.value);
                        setIsOpen(false);
                      }}
                      className="px-4 py-2 text-sm text-white hover:bg-gray-500 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-300 last:border-none"
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* وضعیت کاربر */}
            <div className="flex items-center w-48 text-md gap-2 xl:col-span-12">
              <label className="font-medium">وضعیت کاربر:</label>
              <span className="ml-2 text-md font-medium">
                {disabled ? "غیر فعال" : "فعال"}
              </span>
              <input
                type="checkbox"
                checked={!disabled}
                className="w-6 h-6 cursor-pointer accent-custom-500"
                onChange={() => setdisabled(!disabled)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      
      <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
        <button
          type="button"
          onClick={onSubmit}
          className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
        >
          {!!isEdit ? "بروزرسانی" : "ثبت"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUser;